// frontend/src/components/UI/RatingStar.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";

const RatingStar = ({ rating, size = "default", showLabel = false }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = 5 - Math.ceil(rating);

  const sizeClass =
    size === "small" ? "star-small" : size === "large" ? "star-large" : "";

  return (
    <div className={`rating-stars ${sizeClass}`}>
      {[...Array(fullStars)].map((_, i) => (
        <FontAwesomeIcon
          key={`full-${i}`}
          icon={faStar}
          className="star filled"
        />
      ))}
      {hasHalfStar && (
        <FontAwesomeIcon icon={faStarHalfAlt} className="star half-filled" />
      )}
      {[...Array(emptyStars)].map((_, i) => (
        <FontAwesomeIcon
          key={`empty-${i}`}
          icon={faStar}
          className="star empty"
        />
      ))}
      {showLabel && <span className="rating-label">{rating.toFixed(1)}</span>}
    </div>
  );
};

export default RatingStar;
